let list = []
for (let index = 0; index < 100; index++) {
    list.push({
        id: "artwork-"+index,
        title: "Oeuvre " + index,
        type: 'sculp',
        year: "2020",
        created_year: "1929",
        source: "Source numéro 3",
    })
}

export const getRandom = () =>
    list[Math.floor(Math.random()*list.length)]

export const search = layout => {
    return list.filter(item => {
        if (layout.title && item.title.toLowerCase().indexOf(layout.title.toLowerCase()) !== -1) {
            return true;
        }

        return false;
    })
}

export default list;